//export const URL = 'http://localhost:5000/'

// LAN server deployment — see DEPLOYMENT.md. This value is COMPILED INTO THE
// BUNDLE, so changing the server address means `npm run build` again.
//export const URL = 'http://192.168.1.1:5006/'

// NOTE: SOCKET_URL is not used anywhere. Socket.IO shares the API's HTTP
// server and port, and services/socket.js connects using `URL` above. The
// 5000 here is stale — do not point the socket at it.
//export const SOCKET_URL = 'http://localhost:5000/'

//export const URL = 'http://192.168.1.2:5000/'

export const SOCKET_URL = 'http://localhost:5000/'

//export const URL = 'http://192.168.1.1:5000/'

//export const URL = 'https://zunuodb.yourcareconnect.online/'

//export const URL = 'https://jitrockbd.yourcareconnect.online/'

//export const URL = 'https://rafchikdb.yourcareconnect.online/'

//export const URL = 'https://tepadb.yourcareconnect.online/'

//export const URL = 'https://delabhealthcareplazadb.yourcareconnect.online/'

//export const URL = 'https://jamesbertdb.yourcareconnect.online/'

//export const URL = 'https://ayimbaradb.yourcareconnect.online/'

//export const URL = 'https://shalomdb.yourcaresystem.online/'


//export const URL = 'https://woraecareclinicdb.yourcaresystem.online/'


export const URL = 'https://fairviewclinicdb.yourcaresystem.online/'

//export const URL = 'https://147db.yourcaresystem.online/'

//export const URL = 'https://philanolifelinehospitaldb.yourcaresystem.online/'

//export const URL = 'https://ginamaternityandclinicdb.yourcaresystem.online/'


// Claims interface edition — default (free) vs premium (licensed add-on).
// Entitlement lives in the central DB; the facility's own choice lives in
// system_settings. See backend/migrations/032_claims_premium_license.sql.
export const claimsEdition           = URL + 'claimsEdition'            // GET
export const claimsPremiumStatus     = URL + 'claimsPremiumStatus'      // GET
export const claimsPremiumActivate   = URL + 'claimsPremiumActivate'    // POST
// The facility ASKING for a licence. Writes only the request_* columns in the
// central DB — it can never set status or expires_at, so a facility cannot
// grant itself premium. See CENTRAL_claims_premium_requests.sql.
export const claimsPremiumRequest    = URL + 'claimsPremiumRequest'     // POST
export const claimsEditionPreference = URL + 'claimsEditionPreference'  // PUT

export const companyInfo = URL + 'companyInfo'

// ccc api configuration loading
export const apiConfigNhia = URL + 'api-config/nhia'
// The same eligibility call, made BY THE SERVER. Keeps the API secret off the
// browser, and returns NHIA's own status and body so a 401 can say which of
// "wrong key" / "IP not allow-listed" / "subscription lapsed" it is.
// `reachable: false` means this server has no route to NHIA — the only case in
// which the direct browser call is still worth trying.
export const nhiaGenCCC    = URL + 'api-config/nhia/genCCC'


// Authentication endpoints
export const login = URL + 'login'
export const changepassword = URL + 'changepassword'
export const createstaff = URL + 'createstaff'
export const changestaffpassword = URL + 'changestaffpassword'


// Department
export const reg_department = URL + 'departments'
export const update_department = (id) => URL + `departments/${id}`
export const delete_department = (id) => URL + `departments/${id}`

// HOD 
export const reg_hod = URL + 'hod'
export const update_hod = (id) => URL + `hod/${id}`
export const delete_hod = (id) => URL + `hod/${id}`
export const reg_hod_access = URL + 'hod-access'

// HOD Assignment 
// HOD Assignment endpoints
export const get_all_hod_assignments = URL + 'hod-assignments'
export const get_hod_assignments = URL + 'get_hod-assignments'
export const assign_hod_access = URL + 'hod-assignments'
export const get_hod_asighment = URL + 'hod-assignments'

// Department Users 
export const reg_department_user = URL + 'department-users'
export const update_department_user = (id) => URL + `department-users/${id}`
export const delete_department_user = (id) => URL + `department-users/${id}`
export const get_designations = URL + 'designations'

export const get_user_access = URL + `user-access`

// Desig
export const reg_designation = URL + 'designations'
export const update_designation = (id) => URL + `designations/${id}`
export const delete_designation = (id) => URL + `designations/${id}`

// Role Management 
export const reg_roles = URL + 'roles'

// Access Management endpoints
export const get_hoa_access = URL + 'hoa-access'
export const get_available_access = (section) => URL + `all-access/${section}`

// Department Access Management
export const get_available_department_access = (hodId) => URL + `department-available-access/${hodId}`
export const get_user_assigned_access = (userId) => URL + `department-user-access/${userId}`
export const update_user_access = (userId) => URL + `department-user-access/${userId}`

// NFF Import endpoint
export const nff_import = URL + 'nff-import'

export const get_fee_items = (standard) => URL + `api/fee-items/${standard}`
export const save_fees = URL + 'api/save-fees'

export const get_department_staff = (department) => URL + `department-staff/${department}`
export const check_user_access = (userId) => URL + `check-user-access/${userId}`
export const get_assembly_info = URL + 'assembly-info'


//Role Management
export const newRole = URL + 'newRole'
export const LoadRoles = URL + 'LoadRoles'
export const updateRole = (id) => URL + `updateRole/${id}`
export const delete_Role = (id) => URL + `delete_Role/${id}`


//System Users
export const NewUser = URL + 'NewUser' 
export const LoadUsers = URL + 'LoadUsers'
export const DeleteUser = URL + 'DeleteUser'
export const UpdateUserStatus = URL + 'UpdateUserStatus'


//accessibledepartments
export const accessibledepartments = URL + 'accessibledepartments'
export const AddAccessibledepartments = URL + 'AddAccessibledepartments'
export const RemoveAccessibledepartments = URL + 'RemoveAccessibledepartments'
export const getAcc = URL + 'getAcc'


//Insurance
export const NewInsurance = URL + 'NewInsurance'
export const loadInsurance = URL + 'loadInsurance'
export const insuranceOptions = URL + 'insuranceOptions'
export const updateInsurance = (id) => URL + `updateInsurance/${id}`
export const newPolicy = URL + 'newPolicy'
export const loadpolicy = URL + 'loadpolicy'
export const updatePolicy = (id) => URL + `updatePolicy/${id}`
export const deleteInsurances = (id) => URL + `deleteInsurances/${id}`
export const deletePolicy = (id) => URL + `deletePolicy/${id}`


//Records
export const loadPatients = URL + 'loadPatients'
export const registrationsAnalisis = URL + 'registrationsAnalisis'
export const registrationsAggregated = URL + 'registrationsAggregated'


export const loadPatientsClaToday = URL + 'loadPatientsClaToday'
export const SavePatientInformation = URL + 'SavePatientInformation'
export const uploadPatient = URL + 'uploadPatient'
export const savePatienVitals = URL + 'savePatienVitals'
export const loadPatientsVitals = URL + 'loadPatientsVitals'
export const loadStayAt = URL + 'loadStayAt'


//Pharmacy
export const loadPharmacyPatients = URL + 'loadPharmacyPatients'
export const loadPharmacyPatientsMed = URL + 'loadPharmacyPatientsMed'
export const prescriptionServeAll = URL + 'prescriptionServeAll'
export const updateMedicationStatutt = (medicationId) => URL + `updateMedicationStatutt/${medicationId}`
export const notServedMedicationUrl = (id) => URL + `notServedMedication/${id}`;
export const loadPharmacyVitals = URL + 'loadPharmacyVitals'
export const loadPharmacyclinicalNotes = URL + 'loadPharmacyclinicalNotes'
//  Laboratory results and scan findings for the pharmacy's patient dialog, so
//  the pharmacist can see what came back without leaving the dispensary.
export const loadPharmacyPatientHistory = URL + 'loadPharmacyPatientHistory'
export const loadPharmacyPatientsMedcount = URL + 'loadPharmacyPatientsMedcount'
export const loadPharmacyPatientsChart = URL + 'loadPharmacyPatientsChart'
export const loadPharmacyUserMed = URL + 'loadPharmacyUserMed'
export const loadPatientsMedHistory = URL + 'loadPatientsMedHistory'


//Bill 
export const loadAccountsPatients = URL + 'loadAccountsPatients'
export const loadPatientBill = URL + 'loadPatientBill'
export const billSummaryBulkdb = URL + 'billSummaryBulk'
export const PaymentProcess = URL + 'PaymentProcess'
export const patienHistory = URL + 'patienHistory'
export const DayIncome = URL + 'DayIncome'
export const reversal = URL + 'reversal'
export const loadReversalRequest =URL+'loadReversalRequest'
export const approvalReversal =URL+'approvalReversal'
export const disapprovalReversal =URL+'disapprovalReversal'
export const loadDebtAccount =URL+'loadDebtAccount'
export const loadDebtService =URL+'loadDebtService'
export const userTransaction =URL+'userTransaction'
export const getPendingReversalsdb    =  URL + 'getPendingReversals'
export const getAllPendingReversalsdb  = URL + 'getAllPendingReversals'
export const approveReversaldb    = URL + 'approveReversal';
export const disapproveReversaldb = URL+ 'disapproveReversal';


//bill me
export const loadBillMeService= URL + 'loadBillMeService'
export const SaveBillMe =URL+'SaveBillMe'
export const loadBillMeHistory =URL+'loadBillMeHistory'




export const initiatepayment = URL + 'initiatepayment'

export const checkpaymentstatus = (checkoutId) => URL + `checkpaymentstatus/${checkoutId}`


// Component Access endpoints
export const getComponentPermissions = (roleId, departmentId) => 
 URL + `api/component-access/component-permissions/${roleId}/${departmentId}`
export const updateComponentPermissions = URL + 'api/component-access/component-permissions'
export const getDepartmentComponents = (departmentId) => 
    URL + `api/component-access/department-components/${departmentId}`

// Departments this facility subscribed to at setup (has components configured)
export const getConfiguredDepartments = URL + 'api/component-access/configured-departments'
export const getUserDepartmentComponents = URL + 'getUserDepartmentComponents'
export const getAccessibleDepartments = (roleId) => URL + `getAccessibleDepartments/${roleId}`



//Doctors

export const AIsuggest =URL+'AIsuggest'
export const loadAllPatientsToday =URL+'loadAllPatientsToday'
export const loadInsuredServicesdb =URL+'loadInsuredServices'
export const loadDoctorSuggestionsdb =URL+'loadDoctorSuggestions'
export const loadPatientDiagnosisdb =URL+'loadPatientDiagnosis'
export const servicesToday =URL+'servicesToday'
export const saveServiceProvideddb =URL+'saveServiceProvided'
export const saveOrUpdateDiagnosisdb =URL+'saveOrUpdateDiagnosis'
export const loadDiagnosisOptionsdb =URL+'loadDiagnosisOptions'
export const loadProcedureOptionsdb =URL+'loadProcedureOptions'
export const saveOrUpdateDiagnosisDocumetingdb =URL+'saveOrUpdateDiagnosisDocumeting'
export const saveOrUpdateProceduresDocumetingdb =URL+'saveOrUpdateProcedureDocumeting'
export const loadLabdb =URL+'loadLabs'

// Referral link to the partner diagnostic centre (Doctors → Refer to Diagnostic)
export const diagnosticReferralConfig  = URL+'diagnosticReferral/config'
export const diagnosticReferralCatalog = URL+'diagnosticReferral/catalog'
export const diagnosticReferralCreate  = URL+'diagnosticReferral'
export const diagnosticReferralList    = URL+'diagnosticReferrals'
export const diagnosticReferralRefresh = URL+'diagnosticReferrals/refresh'
export const diagnosticReferralSettings = URL+'diagnosticReferral/settings'
export const diagnosticReferralTest     = URL+'diagnosticReferral/test'
export const diagnosticReferralPrefill  = URL+'diagnosticReferral/prefill'
export const requestLab =URL+'requestLab'
export const loadRequestedLabsdb =URL+'loadRequestedLabs'
export const deleteRequestedLabdb =URL+'deleteRequestedLab'
export const loadAvailableScansdb =URL+'loadAvailableScans'
export const loadRequestedScandb =URL+'loadRequestedScan'
export const loadMedicationsdb =URL+'loadMedications'
export const addMedicationdb =URL+'addMedication'
export const loadRequestedMedsdb =URL+'loadRequestedMeds'
export const updateMedicationdb =URL+'updateMedication'
export const medicationdeletedb =URL+'deleteMedication'
export const loadOtherServicesdb =URL+'loadOtherServices'
export const requestOtherService =URL+'requestOtherService'
export const loadRequestedOtherServicesdb =URL+'loadRequestedOtherServices'
export const getPatientTimeline_medicalHistorydb =URL+'getPatientTimeline_medicalHistory'
export const getPatientVisitDetailsdb =URL+'getPatientVisitDetails'
export const getPatientTimeline_labHistory =URL+'getPatientTimeline_labHistory'
export const getPatientVisitDetailsLab =URL+'getPatientVisitDetailsLab'
export const getPatientTimeline_ScanHistory =URL+'getPatientTimeline_ScanHistory'
export const getPatientVisitDetailsScan =URL+'getPatientVisitDetailsScan'
export const getPatientVitalsHistorydb =URL+'getPatientVitalsHistory'
export const saveAppointmentdb = URL+'saveAppointment'
export const loadAppointmentsdb = URL+'loadAppointments'
export const updateAppointmentdb = URL+'updateAppointment'
export const deleteAppointmentdb = URL+'deleteAppointment'
export const getPatientAppointmentdb = URL+'getPatientAppointment'
export const admitPatient = URL+'admitPatient'
export const getTodayAppointments = URL+'getTodayAppointments'
export const loadMedicationByAge = URL+'loadMedicationByAge'
export const getAttendanceStats = URL+'getAttendanceStats'
export const getDiagnosisStats = URL+'getDiagnosisStats'
export const loadAllInPatients = URL+'loadAllInPatients'
export const loadInPatientDiagnosis = URL+'loadInPatientDiagnosis'
export const loadWardRoundsdb = URL+'loadWardRounds'
export const loadDoctorSuggestionsInpatient = URL+'loadDoctorSuggestionsInpatient'
export const saveAdmissionInfoRound = URL+'saveAdmissionInfoRound'
export const getPatientVitalsHistoryAdmission = URL+'getPatientVitalsHistoryAdmission'
export const getPatientTimeline_labHistoryAdmission = URL+'getPatientTimeline_labHistoryAdmission'
export const getPatientTimeline_ScanHistoryAdmission = URL+'getPatientTimeline_ScanHistoryAdmission'
export const loadPatientsMedHistoryAdmission = URL+'loadPatientsMedHistoryAdmission'
export const outpatientStatsdb = URL+'outpatientStats'
export const inpatientStatsdb = URL+'inpatientStats'
export const savePrecautiondb = URL+'savePrecaution'
export const deleteOrReverseOtherServicedb = URL+'deleteOrReverseOtherService'
export const loadRequestedLabsInpatients = URL+'loadRequestedLabsInpatients'
export const loadRequestedScanInpatient = URL+'loadRequestedScanInpatient'
export const loadRequestedMedsInpatient = URL+'loadRequestedMedsInpatient'
export const loadRequestedOtherServicesInpatient = URL+'loadRequestedOtherServicesInpatient'
export const DischargePatient = URL+'DischargePatient'
export const DeadchargePatient = URL+'DeadchargePatient'
export const loadNurseWardAssignmentsdb = URL + 'loadNurseWardAssignments';
export const getNurseAssignedWardsdb    = URL + 'getNurseAssignedWards';
export const assignNurseToWarddb        = URL + 'assignNurseToWard';
export const removeNurseWardAssignmentdb = URL + 'removeNurseWardAssignment';
export const loadAllInPatientsWardFiltered = URL + 'loadAllInPatientsWardFiltered';
export const LoadUsersdb = URL + 'LoadUsers';


export const ReAdmitPatient = URL+'ReAdmitPatient'
export const saveChronicMedication = URL+'saveChronicMedication'
export const loadChronicMedicationdb = URL+'loadChronicMedication'
export const addWardWithBeds = URL+'addWardWithBeds'
export const loadNurseNotesdb = URL+'loadNurseNotes'
export const saveNurseNotedb = URL+'saveNurseNote'
export const deleteNurseNotedb = URL+'deleteNurseNotedb'
export const searchAllPatientsdb = URL + 'patientsSearch';


//Ward & Beds
export const loadBedsdb = URL+'loadBeds'
export const loadWardsdb = URL+'loadWards'
export const deleteWard = URL+'deleteWard'
export const deleteBed = URL+'deleteBed'
export const loadPendingPatientsdb = URL+'loadPendingPatients'
export const loadWards_bed = URL+'loadWards_bed'
export const loadBedsByWarddb = URL+'loadBedsByWard'
export const assignBedToPatient = URL+'assignBedToPatient'
export const erDirectAdmitdb    = URL+'erDirectAdmit'
export const transferERPatientdb = URL+'transferERPatient'
export const loadDetentionReviewsDuedb     = URL+'loadDetentionReviewsDue'
export const convertDetentionToAdmissiondb = URL+'convertDetentionToAdmission'
export const loadOccupancyStatsdb = URL+'loadOccupancyStats'
export const loadAllInPatientsWard = URL+'loadAllInPatientsWard'
export const loadVitalsHistorydb = URL+'loadVitalsHistory'
export const saveVitalsdb = URL+'saveVitals'
export const deleteVitalsdb = URL+'deleteVitals'
export const loadFBSHistorydb = URL+ 'loadFBSHistory';
export const saveFBSdb = URL +'saveFBS';
export const deleteFBSdb = URL+'deleteFBS';
export const loadRBSHistorydb = URL+ 'loadRBSHistory';
export const saveRBSdb = URL+ 'saveRBS';
export const deleteRBSdb = URL + 'deleteRBS';
export const loadInsurancesddb = URL + 'loadInsurances';
export const loadPatientMedicationsForChartdb = URL+ 'loadPatientMedicationsForChart';
export const saveChartedMedicationdb = URL+ 'saveChartedMedication';
export const loadChartedMedicationsdb = URL+ 'loadChartedMedications';
export const markMedicationAsServeddb = URL+ 'markMedicationAsServed';
export const deleteChartedMedicationdb = URL+ 'deleteChartedMedication';
export const getMedicationSheetHistorydb = URL+ 'getMedicationSheetHistory';
export const nurseDischargeBeddb = URL+ 'nurseDischargeBed';
export const updateWarddb = URL+ 'updateWard';
export const loadAvailableBedsdb = URL+ 'loadAvailableBeds';
export const transferPatientWardBeddb = URL+ 'transferPatientWardBed';
export const loadPatientCurrentBeddb = URL+ 'loadPatientCurrentBed';
export const checkPatientDischargeStatusbd = URL+ 'checkPatientDischargeStatus';
export const patientsByWarddb = URL+ 'patientsByWard';

 


// -----------------------------------------------------------------------------
//Procurement
export const loadProducts = URL + 'loadProducts'
export const loadProductDetails = URL + 'loadProductDetails'
export const addProduct = URL + 'addProduct'
export const removeProductInsurance = URL + 'removeProductInsurance'

export const updateProductInsurances =  URL + 'updateProductInsurances'
export const loadInventory = URL + 'loadInventory'
export const loadDispensaryProducts = URL + 'loadDispensaryProducts'
export const getProductStock = (productName) => URL + `getProductStock/${encodeURIComponent(productName)}`
export const saveRequisitions = URL + 'saveRequisitions'
export const getRequisitions = URL + 'getRequisitions'
export const updateRequisition = (id) => URL + `updateRequisition/${id}`
export const deleteRequisition = (id) => URL + `deleteRequisition/${id}`
export const productTrace = URL + 'productTrace'
export const deleteProduct = URL + 'deleteProduct'
export const processPurchase = URL + 'processPurchase'
export const loadProductsForPurchase = URL + 'loadProductsForPurchase'
export const deleteInventory = (trans_code) => URL + `deleteInventory/${trans_code}`

// Consumables (cotton, plaster, cannula, …) — separate catalogue with its
// own pack/loose stock model. Lives under Procurement → Consumables.
export const consumablesUrl              = URL + 'consumables';
export const consumableByIdUrl   = (id)  => URL + `consumables/${id}`;
export const consumableStockUrl  = (id)  => URL + `consumables/${id}/stock`;
// Consumable purchase orders — mirrors the drug processPurchase /
// loadInventory pair. The frontend "Purchase Orders - Consumables" page
// uses these three endpoints to list, receive, and reverse batches.
export const consumablePurchasesUrl        = URL + 'consumablePurchases';
export const processConsumablePurchaseUrl  = URL + 'processConsumablePurchase';
export const deleteConsumablePurchaseUrl   = (id) => URL + `deleteConsumablePurchase/${id}`;

// Consumable pricing (per-insurance) — mirrors drug pricing endpoints.
export const consumablePricingUrl          = URL + 'consumablePricing';
export const consumablePricingUpdateUrl    = URL + 'consumablePricing/update';

// Consumable stock analysis — roll-up + per-batch detail for the analytics page.
export const consumableStockAnalysisUrl    = URL + 'consumableStockAnalysis';
export const consumableBatchesByIdUrl      = URL + 'consumableBatches';

// Store Pricing APIs

export const loadProductPricing = URL + 'storepricing';
export const storePricingURL = URL + 'api/store-pricing';
export const updateProductPricing = URL + 'api/store-pricing/update'
export const loadStockAnalysis  = URL + 'stockAnalysis'
export const loadInventoryBatches = URL + 'inventoryBatchesCode';
export const adjustStock = URL + 'adjustStock';

// Audit trail
export const auditLogs             = URL + 'auditLogs';


// Sub-branches (multi-tenancy)
export const branchesRequest = URL + 'branches/request';
export const branchesList    = URL + 'branches';
export const branchesApprove = URL + 'branches/approve';
export const branchesReject  = URL + 'branches/reject';
export const branchesSuspend = URL + 'branches/suspend';

// Pharmacy attention (forces pharmacists to resolve every prescription)
export const pharmacyAttentionOpen    = URL + 'pharmacy/attention/open';
export const pharmacyAttentionPending = URL + 'pharmacy/attention/pending';
export const pharmacyAttentionResolve = URL + 'pharmacy/attention/resolve';

// Admission Compliance (vitals + nursing notes per-day rule)
export const complianceSettings    = URL + 'complianceSettings';
export const admissionCompliance   = URL + 'admissionCompliance';
export const complianceViolations  = URL + 'complianceViolations';
export const complianceFollowup    = URL + 'compliance/followup';
export const complianceFollowups   = URL + 'compliance/followups';
export const complianceFollowupDismiss = (id) => URL + `compliance/followup/${id}/dismiss`;

// Database backup — admin-gated full DB dump (streamed as .sql.gz)
export const downloadDatabaseBackup = URL + 'downloadDatabaseBackup';

export const notifyPharmacyRestock  = URL + 'notifyPharmacyRestock';
export const getRestockNotifications = URL + 'getRestockNotifications';
export const markRestockSeen         = URL + 'markRestockSeen';

//  --------------------------------------------------------------------------------------
 


// Laboratory
export const loadHaematologyParameters = URL + 'loadHaematologyParameters'
export const addLabCategory = URL + 'addLabCategory'
export const loadLabCategories = URL + 'loadLabCategories'
export const deleteLabCategory = (id) => URL + `deleteLabCategory/${id}`
export const updateLabCategory = (id) => URL + `updateLabCategory/${id}`
export const addLabParameters = URL + 'addLabParameters'
export const updateLabParameter = (transCode) => URL + `updateLabParameter/${transCode}`
export const deleteLabParameter = (transCode) => URL + `deleteLabParameter/${transCode}`
export const deleteResultC = (transCode) => URL + `deleteResult/${transCode}`



// ==========================================
// NEW ENDPOINTS FOR LABORATORY MY PATIENTS
// ==========================================
export const loadLabPatients = URL+'loadLabPatients'
export const loadLabRequestsOutpatient = URL+'loadLabRequestsOutpatient'
export const loadLabRequestsInpatient = URL+'loadLabRequestsInpatient'
export const loadLabTestParameters = URL + `loadLabTestParameters`
export const loadParameterDetails =  URL + `loadParameterDetails`
export const saveLabResults = URL + 'saveLabResults'


 

export const loadLabResults = URL + 'loadLabResults'
export const labhistoryLoad = URL + 'labhistoryLoad'
export const loadLabHistory = URL + 'loadLabHistory'
export const loadLabResultsByPath = URL + 'loadLabResultsByPath'
export const getLabSummaryToday = URL + 'getLabSummaryToday'
export const getLabRequestsToday = URL + 'api/getLabRequestsToday'

// ==========================================
// SCAN ENDPOINTS FOR LABORATORY
// ==========================================
export const loadScanPatients = (state = 'all') => URL + `loadScanPatients?state=${state}`
export const loadScanRequestsOutpatient = URL + 'loadScanRequestsOutpatient'
export const loadScanRequestsInpatient = URL + 'loadScanRequestsInpatient'
// ==========================================
// SCAN MANAGEMENT ENDPOINTS
// ==========================================
export const loadDistinctScans = () => URL + `loadDistinctScans`
export const loadScanParameters = (scanName) => URL + `loadScanParameters/${encodeURIComponent(scanName)}`
export const loadAllScansWithParameters = () => URL + `loadAllScansWithParameters`
export const saveScanResults = URL + 'saveScanResults'
export const loadExistingScanResults = URL + 'loadExistingScanResults'
export const loadPatientScanReport = URL + 'loadPatientScanReport'
export const loadPatientLabReport = URL + 'loadPatientLabReport'
export const getScanSummaryToday = URL + 'getScanSummaryToday'
export const getTodayScanRequests = URL + 'getTodayScanRequests'

// SCAN MANAGEMENT CRUD ENDPOINTS
export const addScanCategory = URL + 'addScanCategory'
export const updateScanCategory = (oldScanName) => URL + `updateScanCategory/${encodeURIComponent(oldScanName)}`
export const deleteScanCategory = (scanName) => URL + `deleteScanCategory/${encodeURIComponent(scanName)}`
export const addScanParameter = URL + 'addScanParameter'
export const updateScanParameter = (id) => URL + `updateScanParameter/${id}`
export const deleteScanParameter = (id) => URL + `deleteScanParameter/${id}`

// for report
export const loadPharmacyInfo = URL + 'companyInfo'
export const loadPatientLabResultsToday = URL + 'loadPatientLabResultsToday'
export const loadPatientScanResultsToday = URL + 'loadPatientScanResultsToday'
export const loadPatientDocumentation = URL + 'loadPatientDocumentation'
export const DHimsperiods = URL + 'DHimsperiods'
export const patient_inflow = URL + 'patient_inflow'
export const patient_inflow_inpatient = URL + 'patient_inflow_inpatient'
export const monthlyOpdMorbidity = URL + 'monthlyOpdMorbidity'
export const monthlyLabResults   = URL + 'monthlyLabResults'
export const monthlySurgicalOperations = URL + 'monthlySurgicalOperations'
//  Monthly Medication Dispensing Returns — what was dispensed, and to whom.
//  Two calls on purpose: the summary is the whole month, the detail is only the
//  drugs actually picked. See the block comment on the endpoints.
export const monthlyMedicationDispensing = URL + 'monthlyMedicationDispensing'
export const monthlyMedicationDispensingDetail = URL + 'monthlyMedicationDispensingDetail'



//claims
export const insurancetypes = URL +'insurancetypes'
export const claimmonths = URL +'claimmonths'
export const claimdatesbymonth = URL +'claimdatesbymonth'
export const claimServices = URL +'claimServices'
export const claimDiagnosis = URL +'claimDiagnosis'
export const claimprocedures = URL +'claimprocedures'
export const claimmedications = URL +'claimmedications'
export const claimpatients = URL +'claimpatients'
export const updatePatientCInfo = URL +'updatePatientCInfo'
export const saveServiceProvidedCalim = URL +'saveServiceProvidedClaim'
export const servicesTodaycl = URL +'servicesTodaycl'
export const loadPatientDiagnosisclam = URL +'loadPatientDiagnosisclam'
export const saveOrUpdateDiagnosisDocumetingClami = URL +'saveOrUpdateDiagnosisDocumetingClami'
export const saveOrUpdateProcedureDocumetingClami = URL +'saveOrUpdateProcedureDocumetingClami'
export const loadPatientLabsclim = URL +'loadPatientLabsclim'
export const saveOrUpdateLabsClami = URL +'saveOrUpdateLabsClami'
export const loadPatientScansclam = URL +'loadPatientScansclam'
export const saveOrUpdateScansClami = URL +'saveOrUpdateScansClami'
export const loadAvailableScanscilm = URL +'loadAvailableScanscilm'
export const loadMedicationsCalim = URL +'loadMedicationsCalim'
export const deleteMedicationclam = URL +'deleteMedicationclam'
export const claimyears = URL +'claimyears'
export const claimsmonthly = URL +'claimsmonthly'
export const claimsdetails = URL +'claimsdetails'
export const specialtycodes = URL +'specialtycodes'
export const deleteclaim = URL +'deleteclaim'
export const bulkUpdateRequisitions = URL +'bulkUpdateRequisitions'
export const claimsDetailsall = URL +'claimsDetailsall'
//  All four child sets for a whole scheme+month in ONE request — replaces the
//  4-requests-per-claim fetching that made the XML export very slow.
export const claimsReportBundle = URL +'claimsReportBundle'
export const diagnosis_tarf = URL +'diagnosis_tarf'
export const procedureReport = URL +'procedure_tarf'
export const investigationReport = URL +'investigationReport'
export const medicationReport = URL +'medicationReport'
export const loadServices = URL +'loadServices'
export const getServiceInsurances = URL +'getServiceInsurances'
export const updateInsuredService = URL +'updateInsuredService'
export const deleteInsuredService = URL +'deleteInsuredService'
export const saveNewService = URL +'saveNewService'
export const moveServicesToInsurancedb = URL +'moveServicesToInsurance'

export const getDiagnosisInsurances = URL +'getDiagnosisInsurances'
export const updateInsuredDiagnosis = URL +'updateInsuredDiagnosis'
export const deleteInsuredDiagnosis = URL +'deleteInsuredDiagnosis'
export const saveNewDiagnosis = URL +'saveNewDiagnosis'
export const loadDiagnoses = URL +'loadDiagnoses'
export const bulkApplyDiagnosisInsurance = URL +'bulkApplyDiagnosisInsurance'

export const loadProcedures = URL +'loadProcedures'
export const getProcedureInsurances = URL +'getProcedureInsurances'
export const updateInsuredProcedure = URL +'updateInsuredProcedure'
export const deleteInsuredProcedure = URL +'deleteInsuredProcedure'
export const saveNewProcedure = URL +'saveNewProcedure'
export const bulkApplyProcedureInsurance = URL +'bulkApplyProcedureInsurance'

export const loadLabCategoriesbd  = URL +'loadLabCategoriesbd'
export const loadLabsByCategory  = URL +'loadLabsByCategory'
 
export const getLabInsurances  = URL +'getLabInsurances'
export const updateInsuredLab  = URL +'updateInsuredLab'
export const deleteInsuredLab  = URL +'deleteInsuredLab'
export const saveNewLab = URL +'saveNewLab'
export const bulkApplyLabInsurance  = URL +'bulkApplyLabInsurance'
export const medicationStock  = URL +'medicationStock'
export const moveLabToInsurancedb = URL + 'moveLabToInsurance';

// Scan Tariff Setup (mirrors Lab Tariff Setup)
export const loadScanCategoriesbd    = URL + 'loadScanCategoriesbd';
export const getScanInsurances       = URL + 'getScanInsurances';
export const updateInsuredScan       = URL + 'updateInsuredScan';
export const deleteInsuredScan       = URL + 'deleteInsuredScan';
export const saveNewScan             = URL + 'saveNewScan';
export const bulkApplyScanInsurance  = URL + 'bulkApplyScanInsurance';
export const moveScanToInsurancedb   = URL + 'moveScanToInsurance';

// "Apply to many" — write typed-once values to every ticked insurance row,
// or delete every ticked row (Services / Diagnosis / Lab / Procedure / Scan)
export const bulkUpdateInsuredServices  = URL + 'bulkUpdateInsuredServices';
export const bulkDeleteInsuredServices  = URL + 'bulkDeleteInsuredServices';
export const bulkUpdateInsuredDiagnosis = URL + 'bulkUpdateInsuredDiagnosis';
export const bulkDeleteInsuredDiagnosis = URL + 'bulkDeleteInsuredDiagnosis';
export const bulkUpdateInsuredProcedure = URL + 'bulkUpdateInsuredProcedure';
export const bulkDeleteInsuredProcedure = URL + 'bulkDeleteInsuredProcedure';
export const bulkUpdateInsuredLab       = URL + 'bulkUpdateInsuredLab';
export const bulkDeleteInsuredLab       = URL + 'bulkDeleteInsuredLab';
export const bulkUpdateInsuredScan      = URL + 'bulkUpdateInsuredScan';
export const bulkDeleteInsuredScan      = URL + 'bulkDeleteInsuredScan';


// Pharmacy: whether unpaid prescriptions are hidden, visible, or dispensable
export const pharmacyUnpaidVisibility = URL + 'pharmacyUnpaidVisibility';
//  Whether accounts must wait for the nurse to complete a discharge before the
//  patient's bill can be settled. GET reads it, PUT sets 'on' | 'off'.
export const billingDischargeLock = URL + 'billingDischargeLock';

// Laboratory/scan: whether unpaid orders are hidden, visible, or workable.
// Separate key from the pharmacy one - the two rooms are set independently.
export const labUnpaidVisibility = URL + 'labUnpaidVisibility';

// Existing values for the type-and-filter dropdowns on the New Diagnosis and
// New Procedure dialogs (Category, Core Package, Procedure Group)
export const diagnosisFieldOptions = URL + 'diagnosisFieldOptions';
export const procedureFieldOptions = URL + 'procedureFieldOptions';


// Domain renewal invoice (reads the central licence DB — see migration 028)
export const domainRenewalStatus     = URL + 'domainRenewalStatus';
export const acknowledgeDomainNotice = URL + 'acknowledgeDomainNotice';
export const saveDomainRenewal       = URL + 'saveDomainRenewal';
// Boot gate: when the subscription has lapsed the app renders the
// "Service suspended" screen instead of anything else. See LicenseGate.js.
export const systemLicenseStatus     = URL + 'systemLicenseStatus';


export const loadPettyExpenses  = URL +'loadPettyExpenses'
export const savePettyExpense  = URL +'savePettyExpense'
export const updatePettyExpense  = URL +'updatePettyExpense'
export const deletePettyExpense  = URL +'deletePettyExpense'

  
export const approvePettyExpense = URL + 'approvePettyExpense'
export const rejectPettyExpense  = URL + 'rejectPettyExpense'


//SMS (SMS Online GH gateway — see backend/services/SmsService.js)

// Composer & recipient pickers
export const smsInsuranceTypes  = URL + 'smsInsuranceTypes'
export const smsMonths          = URL + 'smsMonths'
export const smspatients        = URL + 'smspatients'
export const smsReligions       = URL + 'smsreligions'

// Send + history + gateway health
export const SmsSend            = URL + 'smssend'         // POST { recipients, message, kind? }
export const smsLog             = URL + 'smsLog'          // GET  ?status=&kind=&search=&limit=
export const smsBalance         = URL + 'smsBalance'      // GET

// Provider settings (admin only) + registration welcome trigger
export const smsSettings        = URL + 'sms/settings'    // GET / PUT

// Pharmacy stock control master switch. OFF = prescribing and billing ignore
// dispensary stock entirely (for facilities that don't run a stocked pharmacy).
export const stockControlSetting = URL + 'stockControlSetting'  // GET / PUT

// Lab / scan stock enforcement (migration 034). Two independent switches, both
// default OFF, and a test with no recorded consumables is never refused.
export const serviceStockSetting = URL + 'serviceStockSetting'  // GET / PUT { kind, enabled }
// What each test or scan consumes — the mapping the gate checks against.
export const serviceConsumables  = URL + 'serviceConsumables'   // GET / POST
export const deleteServiceConsumable = (id) => URL + `serviceConsumables/${id}`  // DELETE
export const smsWelcome         = URL + 'sms/welcome'     // POST { tel, patientName, patientId, facilityName }

// Appointment reminder — SMS Online GH v5 does not support scheduled
// delivery, so this now sends IMMEDIATELY. The name is kept so
// existing call sites (Doctors/OutPatient, Claims/OutPatient) work.
export const scheduleAppointmentSms = URL + 'sms/appointment'  // POST { tel, patientName, appointmentDate, appointmentTime, appointmentType, facilityName }


// Writen Off 
export const saveWriteOff   = URL + 'saveWriteOff'
export const listWriteOff   = URL + 'listWriteOff';
export const updateWriteOff = URL + 'updateWriteOff';
export const deleteWriteOff = URL + 'deleteWriteOff';
// Admin approval panel
export const loadAllWriteOffRequests = URL + 'loadAllWriteOffRequests';
export const approveWriteOff         = URL + 'approveWriteOff';
export const rejectWriteOff          = URL + 'rejectWriteOff';

// id card 

export const getCardColors   = URL + 'getCardColors'
export const saveCardColors  = URL + 'saveCardColors';
export const getCardPrinterType  = URL + 'getCardPrinterType';   // GET
export const saveCardPrinterType = URL + 'saveCardPrinterType';  // PUT
export const getInsurancePartners    = URL + 'getInsurancePartners';     // GET  — active only (for card)
export const getAllInsurancePartners  = URL + 'getAllInsurancePartners';   // GET  — all (for admin)
export const addInsurancePartner     = URL + 'addInsurancePartner';       // POST
export const updateInsurancePartner  = URL + 'updateInsurancePartner';    // PUT
export const deleteInsurancePartner  = URL + 'deleteInsurancePartner'; 
export const getIdCardAmount  = URL + 'getIdCardAmount'; 
export const saveIdCardAmount  = URL + 'saveIdCardAmount'; 
export const checkIdCardCharge  = URL + 'checkIdCardCharge'; 


//Hospital Claims Documentation 

export const outpatientMonthsdb = URL + 'outpatientMonths';
export const outpatientDatesdb = URL + 'outpatientdates';
export const outpatientPatientsdb = URL + 'outpatientPatients';


//
export const generateNote = URL + 'generateNote';
export const generateNurseNote = URL + 'generateNurseNote';
export const generateVitals = URL + 'generateVitals';
export const loadStaffNamesdb = URL + '/loadStaffNames';
 

//SOPS
export const loadAllSOPDocumentsdb = URL + 'loadAllSOPDocuments';
export const loadSOPDocumentByIddb = URL + 'loadSOPDocumentById';
export const createSOPDocumentdb = URL + 'createSOPDocument';
export const updateSOPDocumentdb = URL + 'updateSOPDocument';
export const deleteSOPDocumentdb = URL + 'deleteSOPDocument';


//MEDICAL hISTORY

export const getPatientVisitSummarydb  = URL + 'visitsummary';
export const getVisitFullDetailsdb     = URL + 'visitfulldetails';
export const getNurseNotesdb           = URL + 'nurseNotespatients';
export const getIPDDiagnosisNotesdb    = URL + 'ipddiagnosisnotes';
export const getIPDAdmissionNotesdb    = URL + 'ipdadmissionNotes';


export const visitVitalsdb  = URL + 'visitVitals';
export const visitNurseNotesdb     = URL + 'visitNurseNotes';
export const visitIPDDiagnosisdb           = URL + 'visitIPDDiagnosis';
export const visitIPDAdmissiondb    = URL + 'visitIPDAdmission';



export const uploadSopDocumentdb = URL+ `uploadSopDocument`;


// Human Resources
export const hrListEmployees    = URL + 'api/hr/employees';
export const hrCreateEmployee   = URL + 'api/hr/employees';
export const hrUpdateEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrDeleteEmployee   = (id) => URL + `api/hr/employees/${id}`;
export const hrSummary          = URL + 'api/hr/summary';
export const hrGetSettings      = URL + 'api/hr/settings';
export const hrSaveSettings     = URL + 'api/hr/settings';

// Attendance (biometric device)
export const attendanceToday    = URL + 'api/attendance/today';
export const attendanceUnlinked = URL + 'api/attendance/unlinked';
export const attendanceLink     = URL + 'api/attendance/link';
export const attendanceDevices  = URL + 'api/attendance/devices';
export const attendanceReport   = URL + 'api/attendance/report';


// ============================================================================
//  Investigations module (Laboratory + Scan) — ported from the upgraded system
// ----------------------------------------------------------------------------
//  These 18 endpoints are what the newer Laboratory/Scan setup screens call and
//  this system did not have yet: AI generation of parameters/interpretations,
//  the analyzer inbox, parameter-group ordering, scan format/waiting time, and
//  the lab/scan price-change request flow.
//  Added, not replaced — nothing existing was touched.
// ============================================================================

export const analyzerInbox                = URL + 'analyzerInbox'
export const analyzerInboxDiscard         = (id) => URL + `analyzerInbox/${id}/discard`
export const analyzerInboxDiscardGroup    = URL + 'analyzerInbox/discardGroup'
export const analyzerInboxPatientRequests = (patientId) => URL + `analyzerInbox/patientRequests?patientId=${encodeURIComponent(patientId)}`
export const analyzerInboxPromote         = (id) => URL + `analyzerInbox/${id}/promote`
export const analyzerInboxPromoteGroup    = URL + 'analyzerInbox/promoteGroup'
export const analyzerInboxReplacePrev     = (id) => URL + `analyzerInbox/${id}/replacePrevious`
export const facilitySettingsAPI          = URL + 'facilitySettings'
export const generateLabInterpretation    = URL + 'generateLabInterpretation'
export const generateLabParameters        = URL + 'generateLabParameters'
export const generateLabResults           = URL + 'generateLabResults'
export const generateScanParameters       = URL + 'generateScanParameters'
export const labPriceChangeRequestCreate  = URL + 'labPriceChangeRequest'
export const onboardedDoctorsListUrl      = URL + 'onboardedDoctors'
export const scanPriceChangeRequestCreate = URL + 'scanPriceChangeRequest'
export const updateLabParameterGroup      = URL + 'updateLabParameterGroup'
export const updateScanFormat             = (scanName) => URL + `updateScanFormat/${encodeURIComponent(scanName)}`
export const updateScanWaitingTime        = (scanName) => URL + `updateScanWaitingTime/${encodeURIComponent(scanName)}`

// Request-progress pipeline (paid -> sample_taken -> processing -> done).
// Needed by Common/RequestProgress.js, which the Investigations screens embed.
// Missed in the first pass: the endpoint list was derived from the Laboratory
// folder alone, and this consumer lives in Common/.
export const requestProgressAPI        = (reqNo) => URL + `requestProgress/${encodeURIComponent(reqNo)}`
export const advanceRequestProgressAPI = URL + 'advanceRequestProgress'

// ============================================================================
//  PREMIUM CLAIMS ENDPOINTS
// ----------------------------------------------------------------------------
//  Ported from the Gigatt build alongside Components/Claims/Premium/. These are
//  the endpoints that tree calls and this file did not yet declare.
//
//  URL and SOCKET_URL were deliberately NOT copied - they are this
//  installation environment, not endpoints.
// ============================================================================
// First-run system setup (see backend/setup_routes.js).
// setup_status is the boot gate: while it reports setupRequired the app
// renders the Setup wizard and the login screen is never mounted.
export const setup_status             = URL + 'setup/status'

export const setup_username_available = URL + 'setup/username-available'

export const setup_validate_activation = URL + 'setup/validate-activation'

export const setup_complete           = URL + 'setup/complete'

// Forced password change at first login. Enforces the full password policy
// and clears first_login — the username is never touched.
export const first_password    = URL + 'account/first-password'

export const password_policy   = URL + 'account/password-policy'

// A signed-in user changing their own password. Replaces the old
// changestaffpassword call, which could never succeed from the dialog because
// it verified against trans_code but was only ever sent an email.
export const change_password   = URL + 'account/change-password'

// Which departments THIS facility subscribes to. The 35-department catalogue
// in data/department.js is the same for every install; this is the per-facility
// subset that admin screens filter to. See migration 030.
export const facility_departments = URL + 'facility/departments'

// Facility session policy — currently the idle-logout timeout, in minutes.
// Read by IdleLogout on every load; written from
// Admin Panel → System Settings → Session & Security.
export const security_settings = URL + 'system/security-settings'

// Pharmacy dispensing policy — whether the dispensary may see (and serve) a
// prescription before the patient has paid. Three modes: hide | view | serve.
// Read by the pharmacy list on every load and enforced again on the serve path,
// so a stale screen cannot dispense past the gate. Written from
// Admin Panel → System Settings → Pharmacy & Payment.
export const pharmacy_settings = URL + 'system/pharmacy-settings'

// How many users / department permissions a rename or delete would touch.
export const roleImpact = (id) => URL + `roleImpact/${id}`

export const UpdateUser = URL + 'UpdateUser'

// Read-only preview of what a company rename would touch. The insurance name
// is stored as a string across ~27 columns rather than referenced by id, so
// renaming has to cascade — this reports the blast radius before it happens.
export const insuranceRenameImpact = (id, newName) =>
  URL + `insurance/${id}/rename-impact?newName=${encodeURIComponent(newName)}`

// Accessible departments + their components + this role's granted permissions,
// in one request. Replaces the 1 + 2N sequential calls the Component Access
// screen used to make before it could render anything.
export const getRoleComponentMatrix = (roleId) =>
    URL + `api/component-access/role-matrix/${roleId}`

// Which store the Claims screens are reading, and what is in it. Used to label
// the interface and to answer "where did my claims go" without guessing.
export const claimStoreModel = URL +'claims/store/model'

// One claim in full — header, diagnoses, procedures, investigations, medications
// and the cost rollups. Feeds the editor that drops open inline under a row in
// the Claims Menu. ?id= plus ?source= ('facility' | 'imported'), because a flat
// claim is addressed by the composite 'patientId::date' and an imported one by
// its row id.
export const claimStoreDetail = URL +'claims/store/detail'

// Entries ▸ Documentation ▸ Generate. POST { id, source, includeOther } -> a
// plain-language complaint / history / examination written from what is actually
// on the claim. Sends only the claim's identity: the backend re-reads the claim
// itself, so the note cannot describe a context the browser made up.
// Behind the AI licence, like the Templates suggestions. 422 means the claim has
// no treatment recorded yet and there is nothing to write from.
export const claimStoreDocSuggest = URL +'claims/store/documentation/suggest'

// Documentation ▸ Lab results. The laboratory side of a claim: which
// investigations were requested, which already have results, and which template
// each one maps onto.
//
// The claim carries the NHIS tariff's wording and the lab keeps its template
// under the hospital's, and the two are frequently different strings — see
// backend/claimLabPanel.js. `templates` feeds the dropdown that resolves an
// unmatched wording; `alias` remembers that answer so it is asked once.
//
// Results are NOT saved through these. They go through the laboratory's own
// saveLabResults, so a result entered on a claim is the same row the lab would
// have written and both screens see it.
// The marker on Entries ▸ Documentation: which of the four notes are written,
// how many investigations have results, and whether observations were taken.
// Counted from the stores that hold them, never from a cached flag. Vitals are
// null on an admission — see backend/claimDocStatus.js.
// ── NHIA's verdict on a submitted batch ────────────────────────────────────
// The portal returns an HTML import report after a submission. It is uploaded
// here, and the verdicts are then shown on the claims they belong to — so a
// rejected claim says WHY on the screen where it is edited.
//
// The verdicts are stored rather than the rules re-derived locally, because two
// local approximations were measured against a real report and were wrong by 33x
// and by 1,090 rows. See backend/nhiaImportReport.js.
export const nhiaReportPreview   = URL +'claims/nhia-report/preview'

export const nhiaReportImport    = URL +'claims/nhia-report/import'

export const nhiaReportBatches   = URL +'claims/nhia-report/batches'

export const nhiaReportSummary   = URL +'claims/nhia-report/summary'
// The batch's CLAIMS, one row each, with what NHIA said about every one. The
// report the portal emits cannot be filtered — 6,409 rows in a single 20 MB
// page, 5,280 of them SAVED — so this is the worklist that page could not give.
// ?batch=&outcome=error|warning|all&rule=&q=
export const nhiaReportClaims    = URL +'claims/nhia-report/claims'
// Every claim's outcome, compactly — what a MONTH'S list needs to colour and
// filter its own rows. No messages: those are fetched per claim when opened.
export const nhiaReportOutcomes  = URL +'claims/nhia-report/outcomes'
//  Smart Documentation — investigations a claim is missing, from the lab records
//  and this facility's own claim history. Both POST.
export const smartDocInvestigationsSuggest = URL + 'claims/smart-doc/investigations/suggest'
export const smartDocInvestigationsSave    = URL + 'claims/smart-doc/investigations/save'

// ── Maintenance (department 29) ─────────────────────────────────────────────
// Membership Management. patient.Insurance is the membership number and the
// claims side keys off it; these report how healthy it is and list the patients
// behind each fault. Read-only — correcting a number can merge two people's
// histories, so that is a separate decision.
export const membershipOverview  = URL +'maintenance/membership/overview'
export const membershipList      = URL +'maintenance/membership/list'

// The free-renewal register. A number is taken at the desk and the renewal is
// done later on a phone, so the register has to answer three things: record
// fast, stop two people working the same number, and say how many are left.
export const renewalsSummary     = URL +'maintenance/renewals/summary'
export const renewalsList        = URL +'maintenance/renewals'
export const renewalsCreate      = URL +'maintenance/renewals'
export const renewalsClaim       = URL +'maintenance/renewals/claim'
// PUT `${renewalsUpdate}/${id}`
export const renewalsUpdate      = URL +'maintenance/renewals'

// How fast the campaign is allowed to run. Every renewal is a call to NHIA's
// service, so the ceiling is set here and APPLIED BY THE SERVER — two staff
// with the register open are two browsers each counting only their own clicks.
// GET reads the limits with what has been spent against them; PUT changes them.
export const membershipSettings  = URL +'maintenance/settings'

// ── The clinical review ─────────────────────────────────────────────────────
//  Does the treatment on each claim fit the condition billed? A month is minutes
//  of work, so it is a JOB: POST to start one, GET/DELETE `${job}/${id}` to watch
//  or stop it. See backend/aiClaimReview.js for what it asks and what it refuses.
export const claimAiReview             = URL +'claims/store/ai-review'
export const claimAiReviewJob          = URL +'claims/store/ai-review'
//  One claim's stored answer, for the warning panel at the top of the editor.
export const claimAiReviewOf           = URL +'claims/store/ai-review-of'

// ── The NHIS Medicines List ─────────────────────────────────────────────────
//  The published list carries a PRESCRIBING LEVEL per medicine: the lowest kind
//  of facility NHIA will reimburse for prescribing it. Uploaded on the admin
//  side, consulted ONLY at the claim site.
//
//  preview parses and reports and WRITES NOTHING — applying rewrites the level
//  of the whole NHIS catalogue, so a human confirms against numbers they have
//  seen. `facility` is what level this facility is; with none set, nothing
//  anywhere is checked.
export const nhisMedicinesPreview  = URL +'nhis-medicines/preview'
export const nhisMedicinesApply    = URL +'nhis-medicines/apply'
export const nhisMedicinesVersions = URL +'nhis-medicines/versions'
export const nhisMedicinesFacility = URL +'nhis-medicines/facility'
export const nhisMedicinesCoverage = URL +'nhis-medicines/coverage'
//  The medicines behind a count. "99 are above your level" is not actionable
//  until you can see which 99.
export const nhisMedicinesProducts = URL +'nhis-medicines/products'
//  Products whose NHIS code is missing or belongs to a different medicine, with
//  what the published list says it should be. The apply writes ONLY codes the
//  list offers for that medicine — the server re-derives each one rather than
//  trusting what the browser sends back.
export const nhisMedicinesCodeIssues = URL +'nhis-medicines/code-issues'
export const nhisMedicinesCodeApply  = URL +'nhis-medicines/code-issues/apply'
//  Dose units the published list can fill in. Matched on the CODE and read off
//  the published NAME, because "Diclofenac Tablet, 50 mg" states the strength
//  and the facility's own "DICLO TAB 50MG" often does not. Fills only what is
//  EMPTY — a dose unit already recorded is somebody's decision.
export const nhisMedicinesDoseUnits  = URL +'nhis-medicines/dose-units'
export const nhisMedicinesDoseApply  = URL +'nhis-medicines/dose-units/apply'
//  The codes already written onto CLAIMS — claim_medications.code, which
//  claimsXmlExport writes straight into <medicineCode>. Fixing store_pro stops
//  new bad lines; this repairs the ones already submitted-and-rejected.
//  Scopeable by ?year=&month= so a batch can be repaired before resubmission.
export const nhisMedicinesClaimCodes = URL +'nhis-medicines/claim-codes'
export const nhisMedicinesClaimApply = URL +'nhis-medicines/claim-codes/apply'
//  The codes NHIA ITSELF rejected, read out of the imported report rather than
//  guessed at. The apply rewrites each in all three places a medicine code
//  lives — claim_medications, store_pro and medication — because fixing one
//  leaves the others to re-create the fault.
export const nhisMedicinesRejected      = URL +'nhis-medicines/rejected-codes'
export const nhisMedicinesRejectedApply = URL +'nhis-medicines/rejected-codes/apply'

// Eligibility — what NHIA says when asked for a CCC. A renewal has THREE
// outcomes, not two: it works now, it works from a date in the future (a long
// lapse takes weeks to come alive), or it does not work. The whole response is
// stored, so a question nobody has thought of yet is still askable.
export const eligibilityCheck    = URL +'maintenance/eligibility/check'
export const eligibilityOverview = URL +'maintenance/eligibility/overview'
export const eligibilityHistory  = URL +'maintenance/eligibility/history'

// ── Dormant-member finder (Admin Panel ▸ Database Tools) ────────────────────
// Finds members who have not attended for a year or more — the people worth
// offering a free renewal to — and loads their numbers into the register.
//
// Every call carries a key that the SERVER checks against MAINTENANCE_KEY in
// its environment. The browser only collects it; it never decides, and the key
// is never a constant in this bundle. With no key configured the tool is off.
export const dormancyDatabases   = URL +'maintenance/dormancy/databases'
export const dormancyScan        = URL +'maintenance/dormancy/scan'
export const dormancyImport      = URL +'maintenance/dormancy/import'
//  Other servers. All POST, all behind the same maintenance key.
export const dormancyServers      = URL +'maintenance/dormancy/servers'
export const dormancyServerSave   = URL +'maintenance/dormancy/servers/save'
export const dormancyServerTest   = URL +'maintenance/dormancy/servers/test'
export const dormancyServerDelete = URL +'maintenance/dormancy/servers/delete'

// One claim's verdicts, for the editor. ?id= or ?ref=
export const claimStoreVerdict   = URL +'claims/store/verdict'

// The five rules that can be corrected mechanically. Preview always precedes the
// write — two of them change a patient's name and a membership number.
export const nhiaFixPreview      = URL +'claims/nhia-report/fix/preview'

export const nhiaFixApply        = URL +'claims/nhia-report/fix'

// ── "Dispensed quantity exceeds the prescription" ──────────────────────────
// The lines NHIA queried for dispensing more than the dose, frequency and
// duration account for, grouped by the fault so one correction settles every
// claim that carries it. Read out of the report's own message rather than
// re-derived: NHIA checks liquids and injections with a pack-size table this
// system does not have, and our own reconcile finds 16 of its 162.
export const nhiaQtyIssues       = URL +'claims/nhia-report/qty-issues'
export const nhiaQtyIssuesApply  = URL +'claims/nhia-report/qty-issues/apply'

export const claimStoreDocStatus     = URL +'claims/store/documentation/status'

// ── An admission's documentation: the STAY, day by day ─────────────────────
// The four Documentation boxes are an out-patient encounter — one visit, one
// set of notes. An admission is written by four people at four rhythms: the
// admission assessment, the doctor's ward round each day, the nurse's
// observations several times a day, and the shift notes. This returns all of
// it, plus what was given and requested on each day, in one read.
//
// READ ONLY. The round belongs to the doctor who did it and the observation to
// the nurse who took it; a claims screen must not become a second place either
// can be authored. See backend/inpatientStay.js.
//
// Returns { stay: null, message } — not an error — for a claim that is not an
// admission, has no folder number, or has no visit date. Three different
// situations needing three different things done about them.
export const claimStoreInpatientDoc = URL +'claims/store/documentation/inpatient'

// A ward-round note DRAFTED for one day of the stay, from what that day already
// holds: the observations, the medicines on the chart, the tests requested and
// the nursing notes, plus the day before it for continuity. POST { id, source,
// day }. Never filed — the officer reads it and the doctor owns it.
export const claimStoreInpatientSuggest = URL +'claims/store/documentation/inpatient/suggest'

// Documentation ▸ Vitals. Reads the `vitals` row for the claim's patient on the
// claim's visit date, classifies each reading the way triage does, and returns
// the clinical context /generateVitals needs.
//
// There is no claims-side WRITE here on purpose: observations are saved through
// savePatienVitals, the triage screen's own endpoint, so a reading entered on a
// claim is the same row that appears on the patient's chart.
// Entries ▸ Past History. The patient's other attendances, from BOTH this
// hospital's visit register AND the member's other claims.
//
// The register alone was the old source, and it is empty for every imported
// member — they were never registered here. Their attendances live in the claims:
// 1,648 members in this database have more than one, up to ten.
export const claimStoreHistory       = URL +'claims/store/history'

export const claimStoreVitals        = URL +'claims/store/vitals'

export const claimStoreLabs          = URL +'claims/store/labs'

//  The same lab tab for a visit that has no claim row — the original claims
//  panel, which requests labs straight into lab_charge. Same response shape as
//  claimStoreLabs, so one component renders both.
export const claimStoreLabsVisit     = URL +'claims/store/labs/visit'
export const claimStoreLabPanel      = URL +'claims/store/labs/panel'

export const claimStoreLabTemplates  = URL +'claims/store/labs/templates'

export const claimStoreLabAlias      = URL +'claims/store/labs/alias'

export const claimStoreLabSuggest    = URL +'claims/store/labs/suggest'

// Saving the Member Details card. PUT with ?id= and ?source=; the body is a patch
// and the backend reads only its own whitelist from it (claimStore.BIO_FIELDS).
// Responds with the RE-READ claim, not an echo of the patch, so the screen shows
// what the database accepted rather than what was typed.
export const claimStoreBio = URL +'claims/store/bio'

// What a save would imply, asked before committing to it. Read-only. The visit
// date decides which month a claim is counted in, and a typed-in claim's folder
// number is what its medications and diagnoses are matched on — so those get named
// in the confirmation rather than discovered afterwards.
export const claimStoreBioPreview = URL +'claims/store/bio/preview'

// Putting a claim's service back in agreement with its own rows: the fix for an
// admission billed on an out-patient tariff, and for a principal that was never
// flagged. POST { ids: [], dryRun }. Derived from the claim's highest-tariff
// procedure, else its principal diagnosis — never invented, so a claim carrying
// nothing but OPD codes comes back `unfixable` instead of being given one.
//
// DRY RUN UNLESS dryRun IS EXPLICITLY false. This acts on a whole selection and
// there is no undo, so the before/after is shown first.
export const claimStoreRepair = URL +'claims/store/repair'

// ── Bulk deletion of claims matching one completeness gap ───────────────────
// For claims that arrive unusable and can NEVER be completed — an NHIA claim
// with no CCC being the case this was built for, since the code is read off the
// member's card and cannot be derived at the facility. Removing 117 of those one
// at a time through /deleteclaim is 117 confirmations.
//
// PREVIEW FIRST, ALWAYS. There is no undo, and the preview is what names the
// patients rather than only counting them.
//
// Deletes the CLAIM ONLY: the claim_information row and its normalised copy in
// claims. The patient, the visit, diagnoses, procedures, prescriptions and lab
// results are untouched.
//
// Requires an administrator's re-entered password AND exactly one insurance
// scheme. The scheme is not a convenience — "no CCC" is a real defect for NHIA
// (330 blank of 20,493 claims) and completely normal for Premier Health
// Insurance (1,304 blank of 1,317), so running it across all schemes at once
// would delete nearly every Premier claim to remove a handful of bad NHIA ones.
export const claimsDeleteByGapPreview = URL +'claims/delete-by-gap/preview'
export const claimsDeleteByGap = URL +'claims/delete-by-gap'

// ── ONE claim, from the row it is on ───────────────────────────────────────
// DELETE ?id=&source=facility|imported. Both are required: a typed-in claim 540
// and an imported claim 540 are different patients.
//
// Deletes BOTH SIDES of whichever claim it is. A prepared typed-in claim exists
// twice — the claim_information original and a normalised copy in `claims` —
// and the list shows only the copy. Removing the copy alone lets the next
// "prepare the month" put the claim back; removing the original alone leaves
// the copy, which is what the XML export reads.
//
// The patient is untouched: diagnoses, prescriptions, labs and vitals live on
// the clinical record, not on the claim. So does the NHIA verdict — see
// migration 054 for why losing it would hide why a claim was deleted.
export const claimsDeleteOne = URL +'claims/store/claim'

// ── Claim validation rules (Claims → Claim Rules) ──────────────────────────
// The configurable format rules behind the "wrong format" checks in the
// Advanced Filter: how long a membership number or CCC must be, and which
// characters it may contain, per insurance scheme. One endpoint, three verbs —
// GET everything the screen needs, PUT one rule, DELETE a scheme's override so
// it falls back to the default. See backend/claimFieldRules.js.
export const claimRules = URL + 'claims/rules'

// Dose units, per DRUG rather than per claim. NHIA refuses a medicine line with
// no dose unit, and the same drug is missing its unit on every claim carrying it
// — so GET lists the medications (with a suggested value derived from the drug's
// own strength or name) and POST applies what was typed to every affected line
// in the month. DRY RUN unless dryRun is explicitly false.
export const claimStoreDoseUnits = URL +'claims/store/dose-units'

// AI coding from the visit's own notes: list the month's claims lacking a
// diagnosis / service / attendance, suggest (≤5 per call), apply what was approved.
export const claimAiCodingClaims  = URL +'claims/store/ai-coding/claims'
export const claimAiCodingSuggest = URL +'claims/store/ai-coding/suggest'
export const claimAiCodingApply   = URL +'claims/store/ai-coding/apply'

// Condition Templates (as in Gigatt): the library, validate-without-saving, one
// template. And the READ-ONLY check of claims against a template.
export const conditionTemplates     = URL + 'claims/condition-templates'

//  ── PUTTING A TEMPLATE ONTO CLAIMS ──────────────────────────────────────────
//  templateApplyCheck judges every claim and WRITES NOTHING: each one is measured
//  against its own patient's date of birth, gender and attendance, so the officer sees
//  which claims can take the template before any of them do.
//
//  templateApply writes — and defaults to a dry run, because 'replace' deletes the
//  claim's existing entries. Send dryRun: false to mean it.
export const templateApplyCheck = URL + 'claims/template-apply/check'
export const templateApply      = URL + 'claims/template-apply'
export const conditionTemplateCheck = URL + 'claims/condition-templates/check'
export const conditionTemplate      = (id) => URL + `claims/condition-templates/${id}`
export const claimTemplateCheck     = URL + 'claims/template-check'

// AI licence + provider for this facility (central ai_license). The screens use
// it to show or hide AI buttons by the same rule the server enforces.
export const aiStatusUrl            = URL + 'ai/status'

//  Medication DRUG CODES, fixed per drug rather than per claim. GET lists the
//  uncoded drug names with a suggestion from store_pro where there is one; POST
//  applies them across every month AND writes the code into store_pro, so the
//  next prescription of that drug carries it instead of recreating the gap.
//  POST is a dry run unless dryRun:false is sent explicitly.
export const claimStoreMedicationCodes = URL +'claims/store/medication-codes'

// Options for the SERVICE dropdown. ?age= in years and ?attendance=, because the
// NHIS booklet splits many services at 12 years — under that is a child service,
// 12 and over an adult one. Served from the NHIS tariff book once that import has
// been run, and from the G-DRG catalogue until then.
export const claimStoreServices = URL +'claims/store/services'

// Procedures on one claim. The catalogue is procedure_tarf, priced per scheme, so
// the claim's insurer is part of the lookup. `dates` answers which days a
// procedure may be dated to: the visit day for an OPD attendance, every day of
// the stay for an admission. The row endpoint is one URL for add / edit / remove.
export const claimStoreProcedureTariff = URL +'claims/store/options/procedure-tariff'

export const claimStoreProcedureDates  = URL +'claims/store/procedure/dates'

export const claimStoreProcedure       = URL +'claims/store/procedure'

// Diagnoses on one claim. The catalogue is diagnosis_tarf where it is loaded —
// priced per scheme, carrying the G-DRG — and the ICD-10 reference list otherwise.
export const claimStoreDiagnosisTariff = URL +'claims/store/options/diagnosis-tariff'

export const claimStoreDiagnosis       = URL +'claims/store/diagnosis'

// Investigations on one claim. The catalogue is lab_prices + scan_price — the same
// tables /loadLabs reads — priced per scheme and keyed on the test's name, because
// most rows carry no G-DRG.
export const claimStoreInvestigationTariff = URL +'claims/store/options/investigation-tariff'

export const claimStoreInvestigation       = URL +'claims/store/investigation'

// Medications on one claim. The catalogue is store_pro — the table
// /loadMedicationsCalim reads — priced per scheme and keyed on the drug's name.
export const claimStoreMedicationCatalogue = URL +'claims/store/options/medication-catalogue'

export const claimStoreMedication          = URL +'claims/store/medication'

// The last time this drug was prescribed to a patient of this age group, so the
// prescription fills itself in from practice rather than being typed from scratch.
export const claimStoreMedicationPattern   = URL +'claims/store/medication/pattern'

// ── One catalogue entry, and repairing it at the root ────────────────────────
//  Opened from the billed-content filter, where an officer can see that a code or
//  a name is wrong across hundreds of claims. Three calls, and the order is the
//  safety design: read what is there, preview what a change would do with the
//  exact counts, then apply — and the apply refuses a preview whose figures have
//  moved. See backend/catalogueEntry.js.
export const claimStoreCatalogueEntry        = URL +'claims/store/catalogue-entry'

export const claimStoreCatalogueEntryPreview = URL +'claims/store/catalogue-entry/preview'

export const claimStoreCatalogueEntryRepair  = URL +'claims/store/catalogue-entry/repair'

// What is actually IN a month — the diagnoses, procedures, medications and
// services present, each with how many CLAIMS carry it. Feeds the Claims Menu's
// Advanced Filter pick-lists. Takes the same scoping params as /claimsdetails, so
// the counts in the dialog reconcile with the list behind it.
export const claimsDetailsFacets = URL + 'claimsdetails/facets'

// Multi Vet — the claim editor's own work (diagnoses, procedures, lab/scan,
// medications) applied to a filtered set of claims. Preview writes nothing and
// reports per claim; the commit loops the SAME claimStore writers the single-claim
// editor uses, one claim at a time, and records the run. A run spanning more than
// one facility is refused.
// What the CHOSEN claims already contain — patient, visit, and every diagnosis,
// procedure, test and drug on each — read before anything is applied so the
// selection can be reviewed rather than trusted as a count.
// NHIA e-Claims XML, generated from the NORMALISED claim model and scoped by
// facility, month, date range and attendance. Returns the file as an attachment.
export const claimsXmlExport = URL + 'claims/export/xml'

export const claimsMultiVetSelection = URL + 'claims/multivet/selection'

export const claimsMultiVetPreview = URL + 'claims/multivet/preview'

export const claimsMultiVet        = URL + 'claims/multivet'

export const claimsMultiVetHistory = URL + 'claims/multivet/history'

//  A whole ROUTINE in one pass — a basket holding diagnoses, labs, drugs and
//  procedures together, applied once instead of four separate single-section runs.
export const claimsMultiVetBatch    = URL + 'claims/multivet/batch'

//  Saved baskets. A routine is a basket you got right once; every month after, it
//  is picked from a list rather than retyped from memory.
export const claimsMultiVetRoutines = URL + 'claims/multivet/routines'

// ── Install profile ─────────────────────────────────────────────────────────
// Whether this installation is a hospital ('facility') or a Gigatt Apex claims
// bureau, and which departments it gets. Deliberately NOT under /api — it is
// read during boot alongside setup/status, before any department has mounted.
export const installProfile = URL + 'install/profile'

// ── IT / ICT department ─────────────────────────────────────────────────────
// Facility Onboarding + NHIS Imports, ported from the standalone Gigatt
// project. Names match the source's BaseURL exactly so the two components
// compile unmodified — do not rename them.
export const adminClientFacilities       = URL + 'api/admin/client-facilities'

export const adminClientFacilityById     = (id) => URL + `api/admin/client-facilities/${id}`

export const adminClientFacilityEntitle  = (id) => URL + `api/admin/client-facilities/${id}/entitlements`

export const adminClientFacilityCccVerify   = (id) => URL + `api/admin/client-facilities/${id}/ccc/verify`

export const adminClientFacilityCccGenerate = (id) => URL + `api/admin/client-facilities/${id}/ccc/generate`

// The NHIS booklet PDFs. Preview never touches the database; commit runs one
// atomic transaction. Both need python3 + pypdf on the API host.
export const adminNhisImportPreview = URL + 'api/admin/nhis-import/preview'

export const adminNhisImportCommit  = URL + 'api/admin/nhis-import/commit'

export const nhisFacilityLevels     = URL + 'api/nhis/facility-levels'

// The NHIS tariff SPREADSHEETS, which is a different job from the booklets
// above: these populate insured_services, the table billing charges from.
// The browser parses the .xlsx with exceljs and posts the raw cells, so neither
// endpoint needs Python or a spreadsheet library on the API host. Preview reads
// the table and reports what would change; commit writes in one transaction.
// One builder rather than three constants per sheet type: a release has four
// sheets and they all use the same route shape, so `kind` is the only thing that
// varies. `imports` is the named record of every sheet ever loaded — it survives
// the commit and the session, and is how a facility answers "which tariff are we
// billing on?" long after the import screen was closed.
export const nhisCatalogueImportUrls = (kind) => ({
  preview: URL + `api/nhis-catalogue/${kind}/preview`,
  commit:  URL + `api/nhis-catalogue/${kind}/commit`,
  history: URL + `api/nhis-catalogue/${kind}/imports`,
  record:  (id) => URL + `api/nhis-catalogue/${kind}/imports/${id}`,
})

// Claims XML Import. Preview parses only and writes nothing; commit returns a
// job id immediately and the worker runs in the background, so the frontend
// polls claimsImportJob for progress rather than waiting on the request.
export const claimsImportPreview   = URL + 'api/claims/import/preview'

export const claimsImportCommit    = URL + 'api/claims/import/commit'

export const claimsImportJob       = (id) => URL + `api/claims/import/jobs/${id}`

// Every batch imported so far, newest first. Added for this platform — the
// source only ever fetched the one job it had just started.
export const claimsImportHistory   = URL + 'api/claims/import/history'

// What is inside one batch — the expanded row. Paginated; a real batch is
// thousands of claims.
export const claimsImportBatchClaims = (id) => URL + `api/claims/import/history/${id}/claims`

// Removes a batch and its claims. Refuses by default when the batch contains
// claims already submitted/approved/paid; ?force=1 overrides.
export const claimsImportBatchDelete = (id, force) =>
  URL + `api/claims/import/history/${id}` + (force ? '?force=1' : '')

// Facility logos come back as a server-relative path (/uploads/…), so they are
// joined onto the API origin rather than the frontend's.
export const assetUrl = (p) => (p ? URL.replace(/\/$/, '') + p : null)

// ── Clinical Templates department (licensed add-on) ─────────────────────────
// Every route below 403s unless this facility holds a templates_license row in
// the central licence database. `templatesLicense` is the one exception — it
// sits outside the gate so the UI can decide whether to show the department at
// all, rather than rendering a menu entry that fails on click.
// Names are IDENTICAL to the standalone Gigatt project's, so the ported
// department's ten components compile unmodified. Do not "tidy" them — every
// rename here is a change to a file that was deliberately copied verbatim.
export const templatesLicense      = URL + 'api/templates/license'

export const templateConditions    = URL + 'api/templates/conditions'

export const templateCondition     = (id) => URL + `api/templates/conditions/${id}`

export const templateChild         = (id, cat) => URL + `api/templates/conditions/${id}/${cat}`

export const templateChildRow      = (id, cat, rowId) => URL + `api/templates/conditions/${id}/${cat}/${rowId}`

export const templateSuggest       = (id, cat) => URL + `api/templates/conditions/${id}/${cat}/suggest`

export const templatePending       = (id) => URL + `api/templates/conditions/${id}/pending`

export const templatePendingAccept = (id, pid) => URL + `api/templates/conditions/${id}/pending/${pid}/accept`

export const templatePendingReject = (id, pid) => URL + `api/templates/conditions/${id}/pending/${pid}/reject`

export const templateSources           = URL + 'api/templates/sources'

export const templateAttachedDiagnoses = (gdrgId) => URL + `api/templates/sources/procedure/${gdrgId}/attached-diagnoses`

export const templateSubProcedures     = (gdrgId) => URL + `api/templates/sources/procedure/${gdrgId}/sub-procedures`

export const templateDiagnosisGdrgs    = (diagId) => URL + `api/templates/sources/diagnosis/${diagId}/gdrgs`

// Documentation Sets — matched clinical narratives (uses category 'narratives')
export const templateNarratives        = (id) => URL + `api/templates/conditions/${id}/narratives`

export const templateNarrativeRow      = (id, rowId) => URL + `api/templates/conditions/${id}/narratives/${rowId}`

export const templateNarrativeSuggest  = (id) => URL + `api/templates/conditions/${id}/narratives/suggest`

// Labs attached to a narrative — investigation catalogue is imported-only.
export const templateInvestigations    = URL + 'api/templates/sources/investigations'

export const templateNarrativeLabs         = (narrId) => URL + `api/templates/narratives/${narrId}/labs`

export const templateNarrativeLabRow       = (narrId, labId) => URL + `api/templates/narratives/${narrId}/labs/${labId}`

export const templateNarrativeLabsSuggest  = (narrId) => URL + `api/templates/narratives/${narrId}/labs/suggest`

// Medications attached to a narrative — imported medicines list only.
export const templateMedicines               = URL + 'api/templates/sources/medicines'

export const templateNarrativeMeds           = (narrId) => URL + `api/templates/narratives/${narrId}/medications`

export const templateNarrativeMedRow         = (narrId, medId) => URL + `api/templates/narratives/${narrId}/medications/${medId}`

export const templateNarrativeMedsSuggest    = (narrId) => URL + `api/templates/narratives/${narrId}/medications/suggest`

// Scans attached to a narrative — imaging INVE codes only.
export const templateScans                   = URL + 'api/templates/sources/scans'

export const templateNarrativeScans          = (narrId) => URL + `api/templates/narratives/${narrId}/scans`

export const templateNarrativeScanRow        = (narrId, scanId) => URL + `api/templates/narratives/${narrId}/scans/${scanId}`

export const templateNarrativeScansSuggest   = (narrId) => URL + `api/templates/narratives/${narrId}/scans/suggest`

// Facility-claim adapter — copies a month of typed-in claims into the
// normalised claim_* tables so the consistency checks, Multi Vet and Repair can
// read them. See backend/facilityClaimAdapter.js.
export const claimsAdaptStatus = URL + 'claims/adapt/status'   // GET  ?year=&month=
export const claimsAdapt       = URL + 'claims/adapt'          // POST { year, month }
